// extracted by mini-css-extract-plugin
export default {"root":"widget-athlete-list-large_root__yRP9C","card":"widget-athlete-list-large_card__UrTFu"};